<div class="view-container">
  <div class="partnerships">
    <ng-container *ngIf="actionablePartnerships">
      <mat-card>
        <mat-card-content>
          <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label>Outstanding partnership requests</label>
          </div>
          <partnership-card *ngFor="let item of actionablePartnerships"
            (transitionPartnershipEvent)="transitionPartnership($event)"
            [item]="item"
            [companyId]="selectedCompany?.id"
            [loading]="selectedPartnershipId === item.id"></partnership-card>
        </mat-card-content>
      </mat-card>  
    </ng-container>
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Your partnerships</label>
          <button 
            mat-flat-button type="button"
            color="accent"
            (click)="onClickAddPartnership()"
            matTooltip="Request Partnership">
            <mat-icon>add_link</mat-icon> Request New Partnership
          </button>
        </div>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search partnerships by name</mat-label>
                <input matInput type="text"
                  [(ngModel)]="searchTerm"
                  (keyup.enter)="loadPartnerships()"
                  (keyup.esc)="searchTerm=''; loadPartnerships()"
                  name="searchTerm"
                  placeholder="Search Name">
                <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadPartnerships()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="10px">
                <button
                  type="submit"
                  mat-flat-button color="primary"
                  (click)="loadPartnerships()"
                  matTooltip="Search"
                  [class.button-spinner]="loading"
                  [disabled]="loading">
                  <mat-icon>search</mat-icon> Search
                </button>
                
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <partnership-card *ngFor="let item of partnerships"
          (transitionPartnershipEvent)="transitionPartnership($event)"
          [item]="item"
          [companyId]="selectedCompany?.id"
          [loading]="selectedPartnershipId === item.id">
        </partnership-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
    <ng-container *ngIf="terminatedPartnerships">
      <mat-card>
        <mat-card-content>
          <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label>Previous partnerships</label>
          </div>
          <partnership-card *ngFor="let item of terminatedPartnerships"
            (transitionPartnershipEvent)="transitionPartnership($event)"
            [item]="item"
            [companyId]="selectedCompany?.id"
            [loading]="selectedPartnershipId === item.id">
          </partnership-card>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
</div>
